import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GeneralChatService
{
    readonly showChatButton = signal<boolean>(true);

    constructor()
    {}

}
